export default __webpack_public_path__ + "static/media/icon-chevron-up.464181b3.svg";